export default __webpack_public_path__ + "static/media/Image_Icon.24bbf75e.svg";